let arr=[
    {name:'例行监测',value:'例行监测'},
    {name:'专项监测',value:'专项监测'},
    {name:'其他',value:'其他'}
]
export default arr